import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoanappService } from 'app/services/loanapp.service';
import { AuthService } from 'app/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-recentactivities',
  templateUrl: './recentactivities.component.html',
  styleUrls: ['./recentactivities.component.css'],
})
export class RecentactivitiesComponent implements OnInit {
  user: any;
  appId: String;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  uId: String;
  appdetails: any;
  insDetails: any;
  dataToShow: any;
  farmerDetails: any;
  appAC: number = 0;
  appRC: number = 0;
  appPC: number = 0;
  cmaNS: number = 0;
  cmaAC: number = 0;
  cmaRC: number = 0;
  cmaPC: number = 0;
  tcount: number = 0;
  loanAppsLoaded: Boolean = false;
  totalRec: number;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private lservice: LoanappService,
    private auth: AuthService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.loanAppsLoaded = false;
    this.user = this.auth.user;

    this.getRecentActivities(this.user['_id']).subscribe(
      (data) => this.gotRecentActivities(data),
      (err) => this.failedToGetRecentActivities(err)
    );
  }

  filterQueryParams() {
    const params: any = {};
    params.page = String(this.p);
    params.limit = String(this.itemsPerPage);

    return params;
  }

  getRecentActivities(uId) {
    this.loanAppsLoaded = false;
    this.dataToShow = null;
    const params = this.filterQueryParams();
    return this.lservice.recentAct(uId, params);
  }

  gotRecentActivities(data) {
    this.loanAppsLoaded = true;

    this.tcount = data['tlapp'];
    this.appAC = data['appA'].length;
    this.appRC = data['appR'].length;
    this.appPC = data['appP'].length;
    this.cmaAC = data['cmaa'].length;
    this.cmaPC = data['cmap'].length;
    this.cmaRC = data['cmar'].length;
    this.cmaNS = data['cmaNS'];
    // if (data['success']) {
    //   this.appdetails = data['data'];
    this.dataToShow = data['recA'];
    this.totalRec = data['receenActTotal'];
  }

  failedToGetRecentActivities(err) {
    this.toastr.error('Error occurred. Please try again.');
    this.loanAppsLoaded = true;
  }

  getNewPage(page) {
    this.p = page;
    this.getRecentActivities(this.user['_id']).subscribe(
      (data) => this.gotRecentActivities(data),
      (err) => this.failedToGetRecentActivities(err)
    );
  }

  rowclick(h) {
    window.location.href =
      '/loanapplicationdetails?id=' + h['appId'] + '&uId=' + h['uId'];
  }
}
